module.exports = ".optionClass\r\n{\r\n  flex: 0 0 150px;\r\n  white-space: initial;\r\n}"